import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function EmergencyRoadsidePage() {
  return <div data-id="element-987">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" style={{
      background: '#000'
    }} data-id="element-988">
        <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-989" />
        <div className="relative z-10" data-id="element-990">
          <p className="text-red-300 font-bold text-sm uppercase tracking-widest mb-3" data-id="element-991">
            24/7 Service
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-992">
            🚨 Emergency Roadside Assistance
          </h1>
          <p className="text-red-100 text-base mt-4 max-w-xl mx-auto" data-id="element-993">
            Stranded in the DMV? We're on the way. Day or night, rain or shine.
          </p>
          <a href="tel:3012549338" className="inline-flex items-center justify-center mt-8 bg-white text-[#822433] hover:bg-gray-100 font-black text-lg px-10 py-4 rounded transition-colors duration-200" data-id="element-994">
            Call Now: (301) 254-9338
          </a>
        </div>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-995">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-996">
          <div data-id="element-997">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-998">
              We Come to You — Anywhere in the DMV
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-999">
              Tire emergencies don't wait for business hours. That's why
              Ameritech Tires offers 24/7 emergency roadside assistance across
              the entire DMV area — Maryland, DC, and Northern Virginia. One
              call and we're on our way.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1000">
              Our roadside team carries the equipment to handle flat tires,
              blowouts, and tire-related emergencies on the spot. We'll get you
              safely back on the road or tow your vehicle to the nearest
              Ameritech location for full service.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1001">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1002">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1003">
              <li className="flex items-start gap-3" data-id="element-1004">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1005" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1006">
                  24/7 availability — 365 days a year
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1007">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1008" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1009">
                  Full DMV area coverage (MD, DC, Northern VA)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1010">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1011" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1012">
                  On-site flat tire repair or spare tire installation
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1013">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1014" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1015">
                  Emergency tire replacement from mobile inventory
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1016">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1017" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1018">
                  Towing to nearest Ameritech location if needed
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1019">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1020" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1021">
                  Fast response times — typically under 45 minutes
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1022">
        <div className="max-w-5xl mx-auto" data-id="element-1023">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1024">
            What to Do When You Have a Blowout
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1025">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1026">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1027">
                1
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1028">
                Stay Calm &amp; Pull Over
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1029">
                Grip the wheel firmly, ease off the gas, and steer to the
                shoulder. Don't brake hard.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1030">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1031">
                2
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1032">
                Turn on Hazard Lights
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1033">
                Make yourself visible to other drivers. Stay in your vehicle if
                it's safe to do so.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1034">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1035">
                3
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1036">
                Call Ameritech
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1037">
                Call (301) 254-9338 and we'll dispatch a technician to your
                location immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1038">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1039">
          Stranded? Call Us Now.
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1040">
          Our emergency line is staffed 24/7. We'll be there fast.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1041">
          <a href="tel:3012549338" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1042">
            Call (301) 254-9338
          </a>
          <Link to="/locations" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1043">
            Find a Location
          </Link>
        </div>
      </section>
    </div>;
}